export default __webpack_public_path__ + "static/media/Protective_Gloves.7e037595.svg";